import { ActionReducer, Action } from '@ngrx/store';
import { initialCompanyListState, ICompanyListState } from '../states/company-list.state';
import { ECompanyListActions, SetCompanySearchFilter, SetCompanyPagination, SetCompanySort } from '../actions/company-list.actions';
import { EActiveYearActions } from '../actions/active-year.actions';

export const companyListReducers: ActionReducer<ICompanyListState, Action<string>> = (
  state = initialCompanyListState,
  action: Action<string>
) => {
  switch (action.type) {
    case ECompanyListActions.SetSearchFilter: {
      const typedAction = action as SetCompanySearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1 // Reset to first page when search changes
      };
    }

    case ECompanyListActions.SetPagination: {
      const typedAction = action as SetCompanyPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case ECompanyListActions.SetSort: {
      const typedAction = action as SetCompanySort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case ECompanyListActions.ClearFilters: {
      return {
        ...initialCompanyListState
      };
    }

    case EActiveYearActions.Changed: {
      // Drop the persisted measurement so the next visit picks up the new active year
      // via the component's defaultMeasurementYear() fallback.
      const { measurement: _dropped, ...rest } = state.searchFilter;
      return {
        ...state,
        searchFilter: rest
      };
    }

    default:
      return state;
  }
};
